import * as React from "react";

class Statuses extends React.Component {
    render() {
        return (
            <div style={{height: 'calc(100% - 70px)'}} >
                <header style={{height: 50, display: "flex"}} className="bo-core-header top-header">
                    <div style={{
                        float: "left",
                        paddingLeft: 4,
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <span className="header-title">Status</span>
                    </div>
                </header>
                <h2 style={{fontSize: 19, borderBottom: 'none', marginLeft: 10, color: '#A3A19F'}}>The current page is under development :)</h2>
            </div>
        );
    }
}

export default Statuses



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/StatusGrid/Statuses.tsx